import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { PrivacyPage } from '@/pages/static/Privacy/PrivacyPage';
/**
 * プライバシーポリシーページ（認証以外のアクセス制限）
 * NOTE: ページ構成統一のため作成してあります。アクセス制限等ができた場合ここに処理を追加する
 */
export const Privacy = () => _jsx(PrivacyPage, {});
